import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Select, Button, Collapse} from 'antd'
import dataSourceAPI from '../../../apis/dataSource'
import Editor from '../../../utils/brace'
import {withTranslation} from 'react-i18next'

const {Panel} = Collapse

class FormModal extends Component {
  formRef = React.createRef()
  state = {
    script: null
  }

  componentDidMount() {
    const {id} = this.props
    dataSourceAPI.versionAction(id).then(res => {
      let result = res.data.data
      this.formRef.current.setFieldsValue({
        name: result.name,
        client: result.client,
      })
      this.setState({
        script: result.script
      })
    })
  }

  render() {
    const {verModalVisible, handlePopupCancel, t} = this.props
    return (
      <>
        <Modal
          title={t(`dataSource.groovy`)}
          width={980}
          closable={false}
          visible={verModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Close" onClick={() => { handlePopupCancel('verModalVisible') }}>{t(`general.close`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 0]}>
              <Col span={12}>
                <Form.Item name="name" label={t(`dataSource.name`)}>
                  <Input maxLength={100} disabled placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item name="client" label={t(`dataSource.module`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled>
                    <Select.Option key="DataSource" value="DATASOURCE">{t(`dataSource.dataSource`)}</Select.Option>
                    <Select.Option key="DataTarget" value="DATATARGET">{t(`dataSource.dataTarget`)}</Select.Option>
                    <Select.Option key="InBoundAPI" value="INBOUNDAPI">{t(`dataSource.inboundApi`)}</Select.Option>
                    <Select.Option key="OutBoundAPI" value="OUTBOUNDAPI">{t(`dataSource.outboundApi`)}</Select.Option>
                    <Select.Option key="Mapping" value="MAPPING">{t(`dataSource.mapping`)}</Select.Option>
                    <Select.Option key="Mappingpre" value="MAPPINGPRE">{t(`dataSource.mappingPre`)}</Select.Option>
                    <Select.Option key="Mappingpost" value="MAPPINGPOST">{t(`dataSource.mappingPost`)}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Collapse defaultActiveKey={['1', '2', '3']}>
                  <Panel header={t(`dataSource.script`)} key="1">
                    {
                      <Editor
                        mode="json"
                        width="100%"
                        height="300px"
                        theme="chrome"
                        enableBasicAutocompletion={false}
                        enableLiveAutocompletion={false}
                        enableSnippets={false}
                        enableEmmet={false}
                        useElasticTabstops={false}
                        setOptions={{useWorker: false}}
                        fontSize="16px"
                        value={this.state.script ? this.state.script : null}
                        readOnly={true}
                        disabled
                      ></Editor>
                    }
                  </Panel>
                </Collapse>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
